<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="time"
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="timeDisplayed"
        :label="$t('field.prog_time')"
        prepend-icon="access_time"
        class="mt-2"
        readonly
        hide-details
        v-on="on"
      />
    </template>

    <v-time-picker
      v-model="time"
      format="24hr"
      full-width
      @change="changeTime"
    >
      <v-btn
        class="bloc ma-0"
        @click="$emit('cancel')"
      >
        {{ $t('words.cancel') }}
      </v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'TimeDialog',

  props: {
    current: { type: String, default: null }
  },

  data () {
    return {
      modal: this.current === null,
      time: null
    }
  },

  computed: {
    timeDisplayed () {
      return this.current ? (
        this.current.indexOf(':') === -1
          ? `${this.current.substring(0, 2)}:${this.current.substring(2)}`
          : this.current
        ) : ''
    }
  },

  mounted () {
    this.time = this.current.indexOf(':') === -1
      ? `${this.current.substring(0, 2)}:${this.current.substring(2)}`
      : this.current
  },

  methods: {
    changeTime (time) {
      this.$refs.dialog.save(time)
      this.$emit('set-time', time)
    }
  }
}
</script>
